module.exports = __webpack_public_path__ + "static/alpgray-8eb8aa8c6a83a58fe6dc741534153967.png";